export const FETCH_AUDITS = 'FETCH_AUDITS' as const;
export const FETCH_AUDITS_SUCCESS = 'FETCH_AUDITS_SUCCESS' as const;
export const FETCH_AUDITS_FAIL = 'FETCH_AUDITS_FAIL' as const;
export const FETCH_AUDITS_CANCEL = 'FETCH_AUDITS_CANCEL' as const;
export const CLEAR_AUDITS = 'CLEAR_AUDITS' as const;

export const FETCH_LATEST_AUDIT = 'FETCH_LATEST_AUDIT' as const;
export const FETCH_LATEST_AUDIT_SUCCESS = 'FETCH_LATEST_AUDIT_SUCCESS' as const;
export const FETCH_LATEST_AUDIT_FAIL = 'FETCH_LATEST_AUDIT_FAIL' as const;
export const FETCH_LATEST_AUDIT_CANCEL = 'FETCH_LATEST_AUDIT_CANCEL' as const;

export const FETCH_AUDITS_PAGE = 'FETCH_AUDITS_PAGE' as const;
